import React, { useState, useEffect } from 'react';

function CDRList() {
  const [cdrs, setCdrs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCDRs();
  }, []);

  const fetchCDRs = async () => {
    const token = localStorage.getItem('token');
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/cdrs`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await response.json();
      
      // Fetch customers to map customer_id to company name
      const customersResponse = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/customers`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      
      const customers = await customersResponse.json();
      const customerMap = {};
      customers.forEach(c => {
        customerMap[c.customer_id] = c.company_name;
      });
      
      // Add company name to each CDR
      const cdrsWithCustomer = data.map(cdr => ({
        ...cdr,
        company_name: customerMap[cdr.customer_id] || 'Unknown'
      }));
      
      setCdrs(cdrsWithCustomer);
    } catch (error) {
      console.error('Error fetching CDRs:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="loading">Loading...</div>;

  return (
    <div className="table-container">
      <h2>Call Detail Records</h2>
      <table>
        <thead>
          <tr>
            <th>CALL TIME</th>
            <th>CUSTOMER</th>
            <th>CALLER ID</th>
            <th>DESTINATION</th>
            <th>DURATION (S)</th>
            <th>COST ($)</th>
            <th>STATUS</th>
          </tr>
        </thead>
        <tbody>
          {cdrs.map(cdr => (
            <tr key={cdr.cdr_id}>
              <td>{new Date(cdr.call_time).toLocaleString()}</td>
              <td>{cdr.company_name}</td>
              <td>{cdr.caller_id}</td>
              <td>{cdr.destination}</td>
              <td>{cdr.billsec}</td>
              <td>${cdr.cost.toFixed(4)}</td>
              <td>
                <span className={`badge badge-${cdr.call_status}`}>
                  {cdr.call_status.toUpperCase()}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default CDRList;
